const giftCardHolders = (state = [], action) => {
    switch(action.type) {
        case 'giftCardHolders':
            return action.payload;
        default:
            return state;
    }
}

export default giftCardHolders;